import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import BottomNav from "./BottomNav";
import Users from "./pages/Users";
import Categories from "./pages/Categories";
import Login from "./pages/Login";
import NotificationBroadcaster from "./pages/NotificationBroadcaster";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const location = useLocation();
  const showBottomNav = location.pathname !== '/login';

  return (
    <div style={{ minHeight: '100vh', background: '#0b1220' }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/users" element={<Users />} />
          <Route path="/notifications" element={<NotificationBroadcaster />} />
          <Route path="/categories" element={<Categories />} />
        </Route>
      </Routes>

      {showBottomNav && <BottomNav />}
    </div>
  );
}

export default App;
